import axios from 'axios';
import store from '@/store';
import { message, Modal } from 'ant-design-vue';
import { isManage } from '@/libs/utils';
import Config from '@/config';
// import { formatDate } from '@/libs/utils';

// axios超时时间60秒，上传下载在具体请求里设置
axios.defaults.timeout = 600 * 1000;
axios.defaults.withCredentials = true;

const pendingRequests = new Map(); // 存储进行中的请求
// 生成请求唯一键（方法+URL+参数）
const getRequestKey = config => {
  return `${config.method}:${config.url}:${JSON.stringify(config.params)}:${JSON.stringify(
    config.data
  )}`;
};

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 请求接口根域名
    config.baseURL = '/';

    // 设置get请求applicaton/json;
    if (config.method === 'get') {
      config.data = null;
    }

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    // 修改语言
    // console.log('store.state.currentLocale',store.state.currentLocale)
    config.headers['Accept-Language'] = store.state.currentLocale;

    // 拦截添加时间戳参数
    config.params = {
      ...config.params,
    };

    const requestKey = getRequestKey(config);
    // 取消前一个相同的请求
    if (pendingRequests.has(requestKey)) {
      const cancel = pendingRequests.get(requestKey);
      cancel(); // 取消请求
      pendingRequests.delete(requestKey);
    }
    // 生成新的 CancelToken 并存入 Map
    config.cancelToken = new axios.CancelToken(cancel => {
      pendingRequests.set(requestKey, cancel);
    });

    return config;
  },
  err => Promise.reject(err)
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // removePending(response.config); //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除

    const requestKey = getRequestKey(response.config);
    pendingRequests.delete(requestKey); // 请求完成后移除

    // 判断是否登录有效
    if (response.status === 200) {
      let data = response.data;
      const code = data.code;

      // 20001, "您还没有登录，请登陆后再进行操作"
      // 20002, "您的登录状态已过期，请重新登录"
      // 20003, "您的账号已在其他机器退出登录，请重新登录"
      // 20004, "您的账号已在其他机器保持登录，如果继续将清除其他机器的登录状态"
      if (code === 20001 || code === 20002 || code === 20003 || code === 20004) {
        try {
          store.commit('clearSession');

          // 跳转登录(管理页面才跳转)
          if (isManage() && response.config.url !== '/api/unauth/info') {
            Modal.destroyAll();
            Modal.warning({
              title: null,
              // eslint-disable-next-line no-unused-vars
              content: h => (
                <div style="color:red;margin-top:-8px;font-size:14px;">
                  {window.$t('com_header_logout_timeout')}
                </div>
              ),
              onOk() {
                window.location.href = '/login';
              },
            });
            store.state.logout = true;
          }
        } catch (err) {
          console.log(err);
        }

        return response.data;
      }

      // code!==0，统一提示错误
      if (code !== 0) {
        // 没有权限时，把错误的接口打印在console
        if (code === 20013) {
          console.error('接口没有权限(URL)：', response.config.url);
        } else {
          if (!Config.noMessageAPIs.includes(response.config.url)) {
            message.error(response.data.message);
          }
        }
      }

      return response.data;
    } else {
      message.error(response.data.message || 'System error!');
      return Promise.reject(response);
    }
  },
  err => {
    // console.log(err.config.url);
    console.log('err', err);
    console.log('err response', err.response);

    if (axios.isCancel(err)) {
      console.log('request cancel');
      throw new Error('cancelled');
    } else {
      const res = err.response || {};
      if (res) {
        // 404
        if (res.status === 404) {
          message.error(window.$t('com_api_error_404'));
          return Promise.reject(err);
        }

        // 500
        if (res.status === 500) {
          message.error(window.$t('com_error_500'));
          return Promise.reject(err);
        }
      }

      // 统一提示网络错误
      message.error(window.$t('com_error_net'));

      return Promise.reject(err);
    }
  }
);

export default axios;
